import { render, staticRenderFns } from "./SiteDomain.vue?vue&type=template&id=79448a6a&"
import script from "./SiteDomain.vue?vue&type=script&lang=js&"
export * from "./SiteDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports